import { formatInteractionDateTime, formatLocalDateTime } from "./dateUtils";
import { formatDuration } from "./formatters";
import { formatPhoneNumber } from "./phoneUtils";
export const processInteractionForModal = (interaction) => {
    if (!interaction)
        return null;
    return {
        ...interaction,
        formattedStartDate: formatInteractionDateTime(interaction.InteractionStartDateUtc),
        formattedEndDate: interaction.InteractionEndDateUtc
            ? formatInteractionDateTime(interaction.InteractionEndDateUtc)
            : null,
        formattedDuration: formatDuration(interaction.CallDurationSeconds),
        formattedPhone: formatPhoneNumber(interaction.FromCallbackNumber || ""),
        formattedSecureMessageSent: interaction.SecureMessageSent
            ? formatLocalDateTime(interaction.SecureMessageSent)
            : null,
        formattedPushNotificationSent: interaction.PushNotificationSent
            ? formatLocalDateTime(interaction.PushNotificationSent)
            : null,
        formattedSecureMessageRead: interaction.SecureMessageRead
            ? formatLocalDateTime(interaction.SecureMessageRead)
            : null,
        formattedCallbackFromMessageId: interaction.CallbackFromMessageId
            ? formatLocalDateTime(interaction.CallbackFromMessageId)
            : null,
    };
};
export const handleFieldCustomizationSave = () => {
};
//# sourceMappingURL=interactionProcessor.js.map